"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vallada-agordina": {
    "1002c479": [{
      "hkey": "08bcfceb",
      "slug": "vallada-agordina",
      "name": "Vallada Agordina",
      "primary": true,
      "skipSearch": false
    }],
    "celat": [{
      "hkey": "08bcfceb",
      "slug": "vallada-agordina",
      "name": "Vallada Agordina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1acf79d8": [{
      "hkey": "08bcfceb",
      "slug": "vallada-agordina",
      "name": "Vallada Agordina",
      "primary": true,
      "skipSearch": false
    }],
    "piaz": [{
      "hkey": "08bcfceb",
      "slug": "vallada-agordina",
      "name": "Vallada Agordina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d3e9e66": [{
      "hkey": "08bcfceb",
      "slug": "vallada-agordina",
      "name": "Vallada Agordina",
      "primary": true,
      "skipSearch": false
    }],
    "toffol": [{
      "hkey": "08bcfceb",
      "slug": "vallada-agordina",
      "name": "Vallada Agordina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;